<template>
  <el-input
    v-if="isEditor"
    v-model="value"
    :maxlength="item?.maxlength"
    :minlength="item?.minLength"
    :placeholder="`请输入${item?.fieldName}`"
    show-word-limit
  />
  <div v-else>{{ value }}</div>
</template>
<script>
import { defineComponent } from 'vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 't-text',
  inheritAttrs: false,
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    return {
      ...controlItemManage(props, context)
    }
  }
})
</script>
